var _module_exports = "<div id=\"cdbl-paypal-button-container\"></div>";;
var path = '/workspace/src/app/components/payments/payments-paypal-button/payments-paypal-button.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;